import Model from './Model'

export default class Booster extends Model {
  resource() {
    return 'boosters'
  }
}
